<template lang="pug">
v-app-bar.topbar(app, fixed, flat)
  v-app-bar-nav-icon.ml-2(
    @click.stop="$emit('toggle-drawer')",
    color="#5b6f90"
  )
  v-toolbar-title.topbar-toolbar-title
    v-row.topbar-content(no-gutters, align="center")
      v-divider.topbar-divider(vertical)
      .topbar-logo(@click="goToDashboard", role="button", tabindex="0", @keyup.enter="goToDashboard")
        LogoControlSoft(v-if="isControl", :h="30", :mh="30", :w="220", :mw="220")
        LogoSySafra(v-else, :h="30", :mh="30", :w="220", :mw="220")
      v-divider.topbar-divider(vertical)
      h2.topbar-title(v-show="$vuetify.breakpoint.smAndUp") {{ title }}

  v-spacer
  .topbar-user(v-if="loggedUserName", v-show="$vuetify.breakpoint.smAndUp")
    v-icon.topbar-user-icon(small, color="#5b6f90") mdi-account-circle-outline
    span.topbar-user-name {{ loggedUserName }}

  v-tooltip(bottom)
    template(v-slot:activator="{ on, attrs }")
      v-btn(
        v-on="on",
        v-bind="attrs",
        icon,
        to="/notificacoes",
        color="primary"
      )
        v-badge(
          x-small,
          :color="notificationStatus ? 'warning' : 'info'",
          overlap,
          bordered,
          dot
        )
          v-icon(:color="notificationStatus ? 'warning' : 'info'")
            | mdi-bell-outline
    span Notificações do Gifnoc

  v-tooltip(bottom)
    template(v-slot:activator="{ on, attrs }")
      v-btn(v-on="on", v-bind="attrs", icon, to="/logout")
        v-icon mdi-logout
    span Sair
</template>

<script>
export default {
  props: {
    isControl: {
      type: Boolean,
      default: true
    },

    title: {
      type: String,
      default: ""
    },

    notificationStatus: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    loggedUserName() {
      const user = this.$store.state.auth.user;
      if (!user) return "";
      return user.name || user.login || "";
    }
  },

  methods: {
    goToDashboard() {
      if (this.$route.path !== "/dashboard") {
        this.$router.push("/dashboard");
      }
    }
  }
};
</script>

<style scoped lang="scss">
.topbar {
  background: #eff4fb !important;
  border-bottom: 1px solid rgba(148, 163, 184, 0.45) !important;
  box-shadow: none !important;
}

.topbar-toolbar-title {
  padding-left: 0 !important;
}

.topbar-content {
  flex-wrap: nowrap;
}

.topbar-title {
  margin: 0;
  font-size: 1.2rem !important;
  font-weight: 600 !important;
  line-height: 1.2;
  white-space: nowrap;
  color: #334155;
}

.topbar-divider {
  align-self: center;
  height: 1.25rem !important;
  margin: 0 0.75rem !important;
  border-color: rgba(148, 163, 184, 0.45) !important;
}

.topbar-user {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  margin-right: 0.5rem;
  padding: 0.25rem 0.625rem;
  border-radius: 999px;
  background: rgba(91, 111, 144, 0.08);
  color: #334155;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;
}

.topbar-user-icon {
  font-size: 18px !important;
}

.topbar-user-name {
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.topbar-logo {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  outline: none;
  transition: opacity 0.15s ease;
}

.topbar-logo:hover {
  opacity: 0.8;
}

.topbar-logo:focus-visible {
  opacity: 0.8;
}
</style>
